import React, { useState, useEffect } from 'react';
import popupImage from '../assets/farzeen-popup.png';

const countryCodes = [
  { code: '+1', country: 'US/CA' },
  { code: '+44', country: 'UK' },
  { code: '+61', country: 'AU' },
  { code: '+91', country: 'IN' },
  { code: '+92', country: 'PK' },
  { code: '+971', country: 'UAE' },
  { code: '+966', country: 'SA' },
  { code: '+974', country: 'QA' },
  { code: '+65', country: 'SG' },
  { code: '+60', country: 'MY' },
  { code: '+63', country: 'PH' },
  { code: '+234', country: 'NG' },
  { code: '+27', country: 'ZA' },
  { code: '+49', country: 'DE' },
  { code: '+33', country: 'FR' },
  { code: '+39', country: 'IT' },
  { code: '+34', country: 'ES' },
  { code: '+31', country: 'NL' },
  { code: '+46', country: 'SE' },
  { code: '+47', country: 'NO' },
  { code: '+45', country: 'DK' },
  { code: '+353', country: 'IE' },
  { code: '+64', country: 'NZ' },
  { code: '+55', country: 'BR' },
  { code: '+52', country: 'MX' },
  { code: '+81', country: 'JP' },
  { code: '+82', country: 'KR' },
  { code: '+86', country: 'CN' },
  { code: '+852', country: 'HK' },
];

const LeadMagnetPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [joinWhatsApp, setJoinWhatsApp] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const hasEntered = sessionStorage.getItem('hasEnteredSite');
    if (!hasEntered) {
      setIsOpen(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (firstName && email) {
      setIsSubmitting(true);
      
      try {
        const fullPhone = phoneNumber ? `${countryCode}${phoneNumber}` : '';
        
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: firstName,
            email: email,
            phone: fullPhone,
            country_code: phoneNumber ? countryCode : '',
            join_whatsapp: joinWhatsApp
          })
        });
        
        if (response.ok) {
          sessionStorage.setItem('hasEnteredSite', 'true');
          window.open('https://stan.store/FarzeenDigitalWealth/p/road-to-10k-monthly-as-a-stay-at-home-mom-', '_blank');
          setIsOpen(false);
        } else {
          sessionStorage.setItem('hasEnteredSite', 'true');
          window.open('https://stan.store/FarzeenDigitalWealth/p/road-to-10k-monthly-as-a-stay-at-home-mom-', '_blank');
          setIsOpen(false);
        }
      } catch (error) {
        console.error('Error saving email:', error);
        sessionStorage.setItem('hasEnteredSite', 'true');
        window.open('https://stan.store/FarzeenDigitalWealth/p/road-to-10k-monthly-as-a-stay-at-home-mom-', '_blank');
        setIsOpen(false);
      }
      
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
      <div 
        className="relative w-full max-w-lg bg-white shadow-2xl overflow-hidden max-h-[95vh] overflow-y-auto"
        style={{ animation: 'fadeIn 0.3s ease-out' }}
      >
        {/* Photo Section */}
        <div className="w-full" style={{ backgroundColor: '#f0ebe6' }}>
          <img 
            src={popupImage} 
            alt="Farzeen" 
            className="w-full h-56 object-cover"
            style={{ objectPosition: 'center 12%' }}
          />
        </div>
        
        {/* Content Section */}
        <div className="p-6 text-center">
          <h2 
            className="text-xl md:text-2xl font-light leading-tight mb-3"
            style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
          >
            $10k-$15K months as a
            <br />
            <span className="italic" style={{ color: '#8b7355' }}>stay at home mom</span>
          </h2>
          
          <p 
            className="text-xs font-light leading-relaxed mb-4"
            style={{ color: '#666' }}
          >
            I'm excited to share this new 90% done-for-you digital marketing system that is helping beginners like you make $10k+/month online without creating a product, showing your face, tech skills, or having a large following.
          </p>
          
          <p 
            className="text-sm font-medium mb-4"
            style={{ color: '#1a1a1a' }}
          >
            Where should I send your <span style={{ color: '#8b7355' }}>FREE TRAINING</span>?
          </p>
          
          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-3">
            <input 
              type="text"
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              className="w-full px-4 py-3 text-sm border rounded-none focus:outline-none focus:border-[#1a1a1a] transition-colors"
              style={{ borderColor: '#e0e0e0' }}
            />
            <input 
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 text-sm border rounded-none focus:outline-none focus:border-[#1a1a1a] transition-colors"
              style={{ borderColor: '#e0e0e0' }}
            />
            
            {/* Phone Number (Optional) */}
            <div className="flex gap-2">
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                className="px-2 py-3 text-sm border focus:outline-none focus:border-[#1a1a1a] transition-colors"
                style={{ borderColor: '#e0e0e0', width: '100px' }}
              >
                {countryCodes.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.code} {c.country}
                  </option>
                ))}
              </select>
              <input 
                type="tel"
                placeholder="Phone (optional)"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ''))}
                className="flex-1 px-4 py-3 text-sm border rounded-none focus:outline-none focus:border-[#1a1a1a] transition-colors"
                style={{ borderColor: '#e0e0e0' }}
              />
            </div>
            
            {/* WhatsApp Checkbox */}
            <label className="flex items-center gap-3 py-2 cursor-pointer justify-center">
              <input 
                type="checkbox"
                checked={joinWhatsApp}
                onChange={(e) => setJoinWhatsApp(e.target.checked)}
                className="w-4 h-4 accent-[#8b7355]"
              />
              <span className="text-sm font-light" style={{ color: '#666' }}>
                Join my <span style={{ color: '#25D366', fontWeight: 500 }}>BFB Community WhatsApp</span> ✓
              </span>
            </label>
            
            {/* CTA Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-4 text-sm tracking-wide font-medium transition-all duration-300 hover:opacity-90 rounded-full disabled:opacity-50"
              style={{ backgroundColor: '#1a1a1a', color: '#ffffff' }}
            >
              {isSubmitting ? 'Please wait...' : 'Yes! I want FREE ACCESS NOW!'}
            </button>
          </form>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default LeadMagnetPopup;
